"use strict";

var _regeneratorRuntime = require("C:\\Med Poc\\med-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _createForOfIteratorHelper = require("C:\\Med Poc\\med-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("C:\\Med Poc\\med-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Med Poc\\med-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextDrawer = void 0;

var Utils_1 = require("../Utils");

var Enums_1 = require("../Enums");

var TextDrawer = /*#__PURE__*/function () {
  function TextDrawer() {
    _classCallCheck(this, TextDrawer);
  }

  _createClass(TextDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount() {
      return 12;
    }
  }, {
    key: "init",
    value: function init(container) {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var options, shapeOptions, _iterator, _step, character;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = container.options;

                if (!(Utils_1.Utils.isInArray(Enums_1.ShapeType.char, options.particles.shape.type) || Utils_1.Utils.isInArray(Enums_1.ShapeType.character, options.particles.shape.type))) {
                  _context.next = 26;
                  break;
                }

                shapeOptions = (_a = options.particles.shape.options[Enums_1.ShapeType.character]) !== null && _a !== void 0 ? _a : options.particles.shape.options[Enums_1.ShapeType.char];

                if (!(shapeOptions instanceof Array)) {
                  _context.next = 23;
                  break;
                }

                _iterator = _createForOfIteratorHelper(shapeOptions);
                _context.prev = 5;

                _iterator.s();

              case 7:
                if ((_step = _iterator.n()).done) {
                  _context.next = 13;
                  break;
                }

                character = _step.value;
                _context.next = 11;
                return Utils_1.Utils.loadFont(character);

              case 11:
                _context.next = 7;
                break;

              case 13:
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](5);

                _iterator.e(_context.t0);

              case 18:
                _context.prev = 18;

                _iterator.f();

                return _context.finish(18);

              case 21:
                _context.next = 26;
                break;

              case 23:
                if (!(shapeOptions !== undefined)) {
                  _context.next = 26;
                  break;
                }

                _context.next = 26;
                return Utils_1.Utils.loadFont(shapeOptions);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 15, 18, 21]]);
      }));
    }
  }, {
    key: "draw",
    value: function draw(context, particle, radius) {
      var character = particle.shapeData;

      if (character === undefined) {
        return;
      }

      var textData = character.value;

      if (textData === undefined) {
        return;
      }

      var textParticle = particle;

      if (textParticle.text === undefined) {
        textParticle.text = textData instanceof Array ? Utils_1.Utils.itemFromArray(textData, particle.randomIndexData) : textData;
      }

      var text = textParticle.text;
      var style = character.style;
      var weight = character.weight;
      var size = Math.round(radius) * 2;
      var font = character.font;
      var fill = particle.fill;
      var offsetX = text.length * radius / 2;
      context.font = "".concat(style, " ").concat(weight, " ").concat(size, "px \"").concat(font, "\"");
      var pos = {
        x: -offsetX,
        y: radius / 2
      };

      if (fill) {
        context.fillText(text, pos.x, pos.y);
      } else {
        context.strokeText(text, pos.x, pos.y);
      }
    }
  }]);

  return TextDrawer;
}();

exports.TextDrawer = TextDrawer;